import { supabaseClient } from './supabaseClient';
import type { DayRow, MonthlySummary } from './types';
import { firstDayOfMonth, toISODate } from './types';

const ensureClient = () => {
  if (!supabaseClient) {
    throw new Error('Supabaseの設定が見つかりません。`.env.local` を確認してください。');
  }
  return supabaseClient;
};

export async function fetchMonthlySummary(
  employeeCode: string,
  month: Date
): Promise<MonthlySummary | null> {
  const supabase = ensureClient();
  const targetMonth = toISODate(firstDayOfMonth(month));

  const { data, error } = await supabase.rpc('summarize_attendance_for_month', {
    _employee_code: employeeCode,
    _target_month: targetMonth // 'YYYY-MM-DD'
  });

  if (error) {
    throw error;
  }

  return (data && data[0]) || null;
}

export async function fetchMonthlyDays(
  employeeCode: string,
  month: Date
): Promise<DayRow[]> {
  const supabase = ensureClient();
  const targetMonth = toISODate(firstDayOfMonth(month));

  const { data, error } = await supabase.rpc('list_attendance_days_for_month', {
    _employee_code: employeeCode,
    _target_month: targetMonth // 'YYYY-MM-DD'
  });

  if (error) {
    throw error;
  }

  return (data ?? []) as DayRow[];
}

export async function fetchAttendanceDaysForPeriod(
  employeeCode: string,
  periodStart: string,
  periodEnd: string
): Promise<DayRow[]> {
  const supabase = ensureClient();

  const { data, error } = await supabase.rpc('list_attendance_days_for_period', {
    _employee_code: employeeCode,
    _period_start: periodStart,
    _period_end: periodEnd
  });

  if (error) throw error;
  return (data ?? []) as DayRow[];
}
